'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement('i', { className: 'ion-ios-star' });

var _ref2 = _react2.default.createElement('i', { className: 'ion-ios-star-half' });

var _ref3 = _react2.default.createElement('i', { className: 'ion-ios-star' });

var _ref4 = _react2.default.createElement('i', { className: 'ion-ios-star-outline' });

var _ref5 = _react2.default.createElement('i', { className: 'ion-ios-star' });

var _ref6 = _react2.default.createElement('i', { className: 'ion-ios-star' });

var _ref7 = _react2.default.createElement('i', { className: 'ion-ios-star' });

/**
 * Determines the number of full, half, or empty stars that need to be displayed for a given specialist's review.
 * @param {number} averageRating average rating taken from database
 * @return {HTML} stars displayed using HTML
 */
var calculateRating = function calculateRating(averageRating) {
	var LOWER_LIMIT = 0.25;
	var UPPER_LIMIT = 0.75;
	var STARS_LENGTH = 5;
	var stars = [];
	if (averageRating !== undefined) {
		if (averageRating >= 0 && averageRating <= STARS_LENGTH) {
			for (var i = 0; i < Math.floor(averageRating); i++) {
				stars.push(_ref);
			}
			if (averageRating % 1 < UPPER_LIMIT && averageRating % 1 > LOWER_LIMIT) {
				stars.push(_ref2);
			} else if (averageRating % 1 >= UPPER_LIMIT) {
				stars.push(_ref3);
			}
			for (var _i = stars.length; _i < STARS_LENGTH; _i++) {
				stars.push(_react2.default.createElement(
					'div',
					{ className: _style2.default.incompleteStar },
					_ref4
				));
			}
			return stars.map(function (item, index) {
				return _react2.default.createElement(
					'div',
					{ key: index, className: _style2.default.reviewStar },
					item
				);
			});
		} else if (averageRating > STARS_LENGTH) {
			for (var _i2 = 0; _i2 < STARS_LENGTH; _i2++) {
				stars.push(_ref5);
			}
			return stars.map(function (item, index) {
				return _react2.default.createElement(
					'div',
					{ key: index, className: _style2.default.reviewStar },
					item
				);
			});
		} else if (averageRating < 0) {
			for (var _i3 = 0; _i3 < STARS_LENGTH; _i3++) {
				stars.push(_ref6);
			}
			return stars.map(function (item, index) {
				return _react2.default.createElement(
					'div',
					{ key: index, className: _style2.default.reviewStarNotApplicable },
					item
				);
			});
		}
	} else {
		for (var _i4 = 0; _i4 < STARS_LENGTH; _i4++) {
			stars.push(_ref7);
		}
		return stars.map(function (item, index) {
			return _react2.default.createElement(
				'div',
				{ key: index, className: _style2.default.reviewStarNotApplicable },
				item
			);
		});
	}
};

var StarRating = function StarRating(props) {
	var averageRating = props.averageRating,
	    className = props.className;

	return _react2.default.createElement(
		'div',
		{ className: _style2.default.reviewStars + ' ' + className },
		calculateRating(averageRating)
	);
};

StarRating.propTypes = {
	averageRating: require('react').PropTypes.number.isRequired,
	className: require('react').PropTypes.string.isRequired
};
StarRating.displayName = 'StarRating';

StarRating.propTypes = {};

StarRating.defaultProps = {
	averageRating: 0,
	className: ''
};

exports.default = StarRating;


//////////////////
// WEBPACK FOOTER
// ./node_modules/star-rating/lib/components/star-rating.js
// module id = 1714
// module chunks = 0